import styled from "styled-components";
import { HeaderDesign } from "@util/types";
import { colors } from "@util/constants";

export const SearchFieldWrapper = styled.div<{
  design?: HeaderDesign
}>`
  position:relative;
  max-width:206px;
  width:100%;
  ${({ design }) => design === `solid` && `
      color:${colors.primary};
  `}
  input[type="text"]{
    border:none;
    border-radius:10em;
    background-color:rgba(255,255,255,0.3);
    width:100%;
    ${({ design }) => design === `solid` && `
        background-color:${colors.lightGrey};
        color:${colors.primary};
    `}
    &::placeholder{
      color:inherit;
    }
    padding:12px 30px;
    &:focus{
      outline:none;
    }
  }
  svg{
    position:absolute;
    top:calc(50% - 8.5px);
    right:30px;
    color:inherit;
  }
`